export const TIPOCLIENTE = ['Transportador', 'Vendedor', 'Ejecutivo', 'Turista']

export const URLPAGINA = 'https://josearturo.com/'

export const ESTADOSUSUARIOS = [
    {
        nombre: 'Solicitante',
        color: '#2a3547'
    },
    {
        nombre: 'Admin',
        color: '#5EA4EC'
    },
    {
        nombre: 'Suspendido',
        color: '#808080'
    },
]

export const CATEGORIAPRODUCTO = [
    {
        nombre: 'mixtos',
        color: '#2a3547'
    },
    {
        nombre: 'menu especial',
        color: '#5EA4EC'
    },
    {
        nombre: 'lapingachos',
        color: '#808080'
    },
    {
        nombre: 'entradas y adicionales',
        color: '#808080'
    },
    {
        nombre: 'bebidas',
        color: '#808080'
    },
]